"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.INFOBOX_TABS = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const ui_1 = require("@completeanatomy/ui");
exports.INFOBOX_TABS = {
    [bridge_schema_1.InfoBoxTabType.Description]: {
        icon: ui_1.Icons.Info,
        key: 'info',
    },
    [bridge_schema_1.InfoBoxTabType.Motion]: {
        icon: ui_1.Icons.Motion,
        key: 'motion',
    },
    [bridge_schema_1.InfoBoxTabType.CrossSections]: {
        icon: ui_1.Icons.Cross_Sections,
        key: 'cross-sections',
    },
    [bridge_schema_1.InfoBoxTabType.BoneParts]: {
        icon: ui_1.Icons.Parts,
        key: 'parts',
    },
    [bridge_schema_1.InfoBoxTabType.BoneSurfaces]: {
        icon: ui_1.Icons.Surfaces,
        key: 'surfaces',
    },
    [bridge_schema_1.InfoBoxTabType.BoneLandmarks]: {
        icon: ui_1.Icons.Landmarks,
        key: 'landmarks',
    },
    [bridge_schema_1.InfoBoxTabType.MuscleOI]: {
        icon: ui_1.Icons.Oi,
        key: 'oi',
    },
    [bridge_schema_1.InfoBoxTabType.OriginTrace]: {
        icon: ui_1.Icons.Origin_Path,
        key: 'origin-path',
    },
    [bridge_schema_1.InfoBoxTabType.BranchesTrace]: {
        icon: ui_1.Icons.Branches,
        key: 'branches',
    },
    [bridge_schema_1.InfoBoxTabType.Innervation]: {
        icon: ui_1.Icons.Innervation,
        key: 'nerves',
    },
    [bridge_schema_1.InfoBoxTabType.ArterialSupply]: {
        icon: ui_1.Icons.Arteries,
        key: 'arteries',
    },
    [bridge_schema_1.InfoBoxTabType.Models]: {
        icon: ui_1.Icons.Models,
        key: 'models',
    },
    [bridge_schema_1.InfoBoxTabType.VideosTreatments]: {
        icon: ui_1.Icons.Infobox_Video_Treatments,
        key: 'treatments',
    },
    [bridge_schema_1.InfoBoxTabType.VideosConditions]: {
        icon: ui_1.Icons.Infobox_Video_Conditions,
        key: 'conditions',
    },
    [bridge_schema_1.InfoBoxTabType.VideosExercises]: {
        icon: ui_1.Icons.Infobox_Video_Exercises,
        key: 'exercises',
    },
    [bridge_schema_1.InfoBoxTabType.VideosStretches]: {
        icon: ui_1.Icons.Infobox_Video_Stretches,
        key: 'stretches',
    },
    [bridge_schema_1.InfoBoxTabType.Craniometrics]: {
        icon: ui_1.Icons.Craniometrics_Infobox,
        key: 'craniometrics',
    },
    [bridge_schema_1.InfoBoxTabType.Sutures]: {
        icon: ui_1.Icons.Sutures_Infobox,
        key: 'sutures',
    },
    [bridge_schema_1.InfoBoxTabType.DrainageTrace]: {
        icon: ui_1.Icons.Origin_Path,
        key: 'drainage-trace',
    },
    [bridge_schema_1.InfoBoxTabType.TributariesTrace]: {
        icon: ui_1.Icons.Branches,
        key: 'tributaries-trace',
    },
    [bridge_schema_1.InfoBoxTabType.Explode]: {
        icon: ui_1.Icons.Multi_Selection_Explode,
        key: 'explode',
    },
};
